import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-TD9ZF8N',
        },
    },
    host: 'www.zalando-lounge.fi',
});
